var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0l3.5,9.669L28,9.931l-8.337,6.238L22.652,26,14,20.186,5.348,26l2.989-9.831L0,9.931l10.5-.262Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14 2.93798828125 L 11.4402904510498 10.00936985015869 L 11.20779991149902 10.65163993835449 L 10.52495956420898 10.6686897277832 L 2.909046173095703 10.85881233215332 L 8.935970306396484 15.36832046508789 L 9.497739791870117 15.788649559021 L 9.293630599975586 16.45991897583008 L 7.121528625488281 23.60323333740234 L 13.44227981567383 19.3561897277832 L 14 18.98144912719727 L 14.55772018432617 19.3561897277832 L 20.87846565246582 23.60323333740234 L 18.70637130737305 16.45991897583008 L 18.50226020812988 15.788649559021 L 19.06402969360352 15.36832046508789 L 25.0909538269043 10.85881233215332 L 17.47504043579102 10.6686897277832 L 16.79220008850098 10.65163993835449 L 16.5597095489502 10.00936985015869 L 14 2.93798828125 M 14 0 L 17.5 9.669000625610352 L 28 9.931119918823242 L 19.66312026977539 16.16899871826172 L 22.65246963500977 26 L 14 20.18622016906738 L 5.34752082824707 26 L 8.336879730224609 16.16899871826172 L 0 9.931119918823242 L 10.5 9.669000625610352 L 14 0 Z",
    stroke: "none",
    fill: "#1a8fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/outline.4c2dab4368c8c2f964a34c792542156d.svg";
export { ForwardRef as ReactComponent };